export default __webpack_public_path__ + "static/media/FavLocationGreen.201fa679.svg";